// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"bfe2951c","361":"c29427a3","450":"f2f8afa7"}[chunkId] + ".chunk.js";
};